import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';
import { Button } from '@flos/react-ui';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackUserClickedNavigateToResumePage } from '../../utils/tracking';
import { scrollPageToTop } from '../../helpers/scrollPageToTop';

type ResumeButtonType = {
    formConfig: FormConfig;
    submitIsLoading: boolean;
    resetError: () => void;
    urlResume: string;
    pageId: string;
};

const ResumeButton: FC<ResumeButtonType> = ({ pageId, formConfig, submitIsLoading, resetError, urlResume }) => {
    const navigate = useNavigate();

    const onClick = () => {
        if (pageId) {
            trackUserClickedNavigateToResumePage(formConfig, pageId);
        }

        navigate(urlResume);
        scrollPageToTop();
        resetError();
    };

    // If the form is medicinsk-forhaandsvurdering the button text is 'Gennemse ansøgning' else 'Gennemse anmeldelse'
    const buttonText = `Gennemse ${formConfig.formId === 'medicinsk-forhaandsvurdering' ? 'ansøgning' : 'anmeldelse'}`;

    return (
        <Button disabled={submitIsLoading} onClick={onClick} size="medium" theme="secondary">
            {buttonText}
        </Button>
    );
};

export default ResumeButton;
